// extracted by mini-css-extract-plugin
export default {"contents":"bF-z","sectionHeading":"cF-z"};